// translations/pages/events/es.js
// Labels of the events section and page, and the texts of every event by its id
// from config/events.cjs. Dates are not written here; the pages format them.

export const eventsPageES = {
  title: 'Eventos',
  upcoming: 'Próximos eventos',
  past: 'Eventos pasados',
  all: 'Todos los eventos',
  items: {
    wikki26: {
      title: 'WiKKI26 – Conferencia de Wildau sobre Inteligencia Artificial',
      description: 'pAIoneer Labs estuvo presente como expositor en la Technische Hochschule Wildau. En el stand se trató cómo se construyen infraestructuras locales de IA en empresas y organizaciones: soberanía de los datos, protección de datos desde el diseño e IA conforme a la ley, sin dependencias innecesarias de soluciones externas en la nube.'
    }
  }
};
